import React from "react";
import styled from "styled-components/macro";
import { CheckIcon } from "lucide-react";
import { useLocation } from "react-router-dom";

import { mediaQueries } from "../../../styles/media.js";
import ProbateLayout from "./ProbateLayout";
import { Sheet } from "./Sheet";

// The title at the sheet body's 40px inset, 16px above the Done mark and 24px above the sheet's
// next child, where the sheet's gap is 16px
const Header = styled.header`
  display: flex;
  flex-direction: column;
  gap: var(--juno-space-4);
  padding: var(--juno-space-8) var(--juno-space-6) var(--juno-space-2);
`;

const Title = styled.h1`
  margin: 0;
  font-size: var(--card-title-font-size);
  line-height: var(--card-title-line-height);
  font-weight: var(--card-title-font-weight);
  letter-spacing: var(--card-title-letter-spacing);
  text-align: center;

  ${mediaQueries.xl} {
    text-align: left;
  }
`;

const DoneMark = styled.p`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--juno-space-4);
  margin: 0;
  font-size: var(--text-base);
  line-height: var(--text-base--line-height);
  font-weight: var(--juno-font-weight-bold);

  ${mediaQueries.xl} {
    justify-content: flex-start;
  }

  svg {
    box-sizing: border-box;
    width: var(--juno-space-7);
    height: var(--juno-space-7);
    /* Leaves a 16px check in the 28px circle */
    padding: calc((var(--juno-space-7) - var(--juno-space-4)) / 2);
    border-radius: var(--radius-4xl);
    background-color: var(--primary);
    color: var(--primary-foreground);
  }
`;

const Details = styled.p`
  margin: 0;
  font-size: var(--text-base);
  line-height: var(--text-base--line-height);
  text-align: center;

  ${mediaQueries.xl} {
    text-align: left;
  }
`;

// A page opened from somewhere other than the dashboard, such as a request group collection, passes its back
// link in the location's state
const ProbatePage = ({ caseRef, title, details, done = false, doneLabel = "Done", back, children }) => {
  const location = useLocation();
  return (
    <ProbateLayout caseReference={caseRef} back={back ?? location.state?.back}>
      <Sheet>
        <Header>
          <Title>{title}</Title>
          {details && <Details>{details}</Details>}
          {done && (
            <DoneMark>
              <CheckIcon aria-hidden="true" strokeWidth={3} />
              {doneLabel}
            </DoneMark>
          )}
        </Header>
        {children}
      </Sheet>
    </ProbateLayout>
  );
};

export default ProbatePage;
